import { render, staticRenderFns } from "./Gruppo.vue?vue&type=template&id=68581f94&scoped=true"
import script from "./Gruppo.vue?vue&type=script&lang=js"
export * from "./Gruppo.vue?vue&type=script&lang=js"
import style0 from "./Gruppo.vue?vue&type=style&index=0&id=68581f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68581f94",
  null
  
)

export default component.exports